'use client';

var _excluded = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import deepmerge from '@mui/utils/deepmerge';
import refType from '@mui/utils/refType';
import composeClasses from '@mui/utils/composeClasses';
import InputBase from "../InputBase/index.js";
import rootShouldForwardProp from "../styles/rootShouldForwardProp.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import createSimplePaletteValueFilter from "../utils/createSimplePaletteValueFilter.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import filledInputClasses, { getFilledInputUtilityClass } from "./filledInputClasses.js";
import { rootOverridesResolver as inputBaseRootOverridesResolver, inputOverridesResolver as inputBaseInputOverridesResolver, InputBaseRoot, InputBaseInput } from "../InputBase/InputBase.js";
import { capitalize } from "../utils/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    disableUnderline = ownerState.disableUnderline,
    startAdornment = ownerState.startAdornment,
    endAdornment = ownerState.endAdornment,
    size = ownerState.size,
    hiddenLabel = ownerState.hiddenLabel,
    multiline = ownerState.multiline;
  var slots = {
    root: ['root', !disableUnderline && 'underline', startAdornment && 'adornedStart', endAdornment && 'adornedEnd', size === 'small' && "size".concat(capitalize(size)), hiddenLabel && 'hiddenLabel', multiline && 'multiline'],
    input: ['input']
  };
  var composedClasses = composeClasses(slots, getFilledInputUtilityClass, classes);
  return _objectSpread(_objectSpread({}, classes), composedClasses);
};
var FilledInputRoot = styled(InputBaseRoot, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return rootShouldForwardProp(prop) || prop === 'classes';
  },
  name: 'MuiFilledInput',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [].concat(_toConsumableArray(inputBaseRootOverridesResolver(props, styles)), [!ownerState.disableUnderline && styles.underline]);
  }
})(memoTheme(function (_ref) {
  var theme = _ref.theme;
  var light = theme.palette.mode === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
  var hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
  var disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
  return _defineProperty(_defineProperty(_defineProperty({
    position: 'relative',
    backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
    borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
    borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut
    }),
    '&:hover': {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
      }
    }
  }, "&.".concat(filledInputClasses.focused), {
    backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
  }), "&.".concat(filledInputClasses.disabled), {
    backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
  }), "variants", [{
    props: function props(_ref2) {
      var ownerState = _ref2.ownerState;
      return !ownerState.disableUnderline;
    },
    style: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      '&::after': {
        left: 0,
        bottom: 0,
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.
      }
    }, "&.".concat(filledInputClasses.focused, ":after"), {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: 'scaleX(1) translateX(0)'
    }), "&.".concat(filledInputClasses.error), {
      '&::before, &::after': {
        borderBottomColor: (theme.vars || theme).palette.error.main
      }
    }), '&::before', {
      borderBottom: "1px solid ".concat(theme.vars ? "rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / ").concat(theme.vars.opacity.inputUnderline, ")") : bottomLineColor),
      left: 0,
      bottom: 0,
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    }), "&:hover:not(.".concat(filledInputClasses.disabled, ", .").concat(filledInputClasses.error, "):before"), {
      borderBottom: "1px solid ".concat((theme.vars || theme).palette.text.primary)
    }), "&.".concat(filledInputClasses.disabled, ":before"), {
      borderBottomStyle: 'dotted'
    })
  }].concat(_toConsumableArray(Object.entries(theme.palette).filter(createSimplePaletteValueFilter()) // check all the used fields in the style below
  .map(function (_ref3) {
    var _palette$color;
    var _ref4 = _slicedToArray(_ref3, 1),
      color = _ref4[0];
    return {
      props: {
        disableUnderline: false,
        color: color
      },
      style: {
        '&::after': {
          borderBottom: "2px solid ".concat((_palette$color = (theme.vars || theme).palette[color]) === null || _palette$color === void 0 ? void 0 : _palette$color.main)
        }
      }
    };
  })), [{
    props: function props(_ref5) {
      var ownerState = _ref5.ownerState;
      return ownerState.startAdornment;
    },
    style: {
      paddingLeft: 12
    }
  }, {
    props: function props(_ref6) {
      var ownerState = _ref6.ownerState;
      return ownerState.endAdornment;
    },
    style: {
      paddingRight: 12
    }
  }, {
    props: function props(_ref7) {
      var ownerState = _ref7.ownerState;
      return ownerState.multiline;
    },
    style: {
      padding: '25px 12px 8px'
    }
  }, {
    props: function props(_ref8) {
      var ownerState = _ref8.ownerState,
        size = _ref8.size;
      return ownerState.multiline && size === 'small';
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: function props(_ref9) {
      var ownerState = _ref9.ownerState;
      return ownerState.multiline && ownerState.hiddenLabel;
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: function props(_ref10) {
      var ownerState = _ref10.ownerState;
      return ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small';
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]));
}));
var FilledInputInput = styled(InputBaseInput, {
  name: 'MuiFilledInput',
  slot: 'Input',
  overridesResolver: inputBaseInputOverridesResolver
})(memoTheme(function (_ref12) {
  var theme = _ref12.theme;
  return _objectSpread(_objectSpread(_objectSpread({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12
  }, !theme.vars && {
    '&:-webkit-autofill': {
      WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
      WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
      caretColor: theme.palette.mode === 'light' ? null : '#fff',
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit'
    }
  }), theme.vars && _defineProperty({
    '&:-webkit-autofill': {
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit'
    }
  }, theme.getColorSchemeSelector('dark'), {
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px #266798 inset',
      WebkitTextFillColor: '#fff',
      caretColor: '#fff'
    }
  })), {}, {
    variants: [{
      props: {
        size: 'small'
      },
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: function props(_ref14) {
        var ownerState = _ref14.ownerState;
        return ownerState.hiddenLabel;
      },
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: function props(_ref15) {
        var ownerState = _ref15.ownerState;
        return ownerState.startAdornment;
      },
      style: {
        paddingLeft: 0
      }
    }, {
      props: function props(_ref16) {
        var ownerState = _ref16.ownerState;
        return ownerState.endAdornment;
      },
      style: {
        paddingRight: 0
      }
    }, {
      props: function props(_ref17) {
        var ownerState = _ref17.ownerState;
        return ownerState.hiddenLabel && ownerState.size === 'small';
      },
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }, {
      props: function props(_ref18) {
        var ownerState = _ref18.ownerState;
        return ownerState.multiline;
      },
      style: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
      }
    }]
  });
}));
var FilledInput = /*#__PURE__*/React.forwardRef(function FilledInput(inProps, ref) {
  var _ref19, _slots$root, _ref20, _slots$input;
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiFilledInput'
  });
  var _props$disableUnderli = props.disableUnderline,
    disableUnderline = _props$disableUnderli === void 0 ? false : _props$disableUnderli,
    _props$components = props.components,
    components = _props$components === void 0 ? {} : _props$components,
    componentsPropsProp = props.componentsProps,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    hiddenLabel = props.hiddenLabel,
    _props$inputComponent = props.inputComponent,
    inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
    _props$multiline = props.multiline,
    multiline = _props$multiline === void 0 ? false : _props$multiline,
    slotProps = props.slotProps,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    other = _objectWithoutProperties(props, _excluded);
  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    disableUnderline: disableUnderline,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    type: type
  });
  var classes = useUtilityClasses(props);
  var filledInputComponentsProps = {
    root: {
      ownerState: ownerState
    },
    input: {
      ownerState: ownerState
    }
  };
  var componentsProps = (slotProps !== null && slotProps !== void 0 ? slotProps : componentsPropsProp) ? deepmerge(filledInputComponentsProps, slotProps !== null && slotProps !== void 0 ? slotProps : componentsPropsProp) : filledInputComponentsProps;
  var RootSlot = (_ref19 = (_slots$root = slots.root) !== null && _slots$root !== void 0 ? _slots$root : components.Root) !== null && _ref19 !== void 0 ? _ref19 : FilledInputRoot;
  var InputSlot = (_ref20 = (_slots$input = slots.input) !== null && _slots$input !== void 0 ? _slots$input : components.Input) !== null && _ref20 !== void 0 ? _ref20 : FilledInputInput;
  return /*#__PURE__*/_jsx(InputBase, _objectSpread(_objectSpread({
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    slotProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other), {}, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
FilledInput.muiName = 'Input';
export default FilledInput;